import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TrackDirective} from '@q9elements/ui-kit/common';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  IconButtonComponent,
  ImageImportComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  SelectModule,
  TextareaFieldComponent,
  TextFieldComponent,
  Q9CreditBalanceWarningComponent
} from '@q9elements/ui-kit/components';
import {AutoGenerateDrilldownDialogComponent} from './auto-generate-drilldown-dialog.component';
import {ImageGenerationImportComponent} from '@q9elements/ui-kit/maps';

@NgModule({
  declarations: [AutoGenerateDrilldownDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    DialogCloseButtonComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    TextFieldComponent,
    TextareaFieldComponent,
    ImageImportComponent,
    IconButtonComponent,
    ContentLoaderComponent,
    InfoMessageComponent,
    Q9TrackDirective,
    ImageGenerationImportComponent,
    SelectModule,
    Q9CreditBalanceWarningComponent
  ],
  exports: [AutoGenerateDrilldownDialogComponent]
})
export class AutoGenerateDrilldownDialogModule {}
